import React, { useEffect } from "react"
import { Row, Col } from "reactstrap"
import styled, { css } from "styled-components"
import { GatsbyImage } from "gatsby-plugin-image"
import { Container } from "reactstrap"
import { media } from "utils/Media"
import FlexibleContentFeatured from "components/FlexibleContent/FlexibleContentFeatured"
import Hero from "components/FlexibleContent/Blocks/Hero"
import Article from "components/shared/Article"
import ContentMax from "components/shared/ContentMax"
// import SidebarCustomBlock from "components/shared/SidebarCustomBlock"
import ContainerMax from "components/shared/ContainerMax"
import Breadcrumbs from "components/shared/Breadcrumbs"
import Text from "components/shared/Text"
import Sidebar from "components/Layout/Sidebar"
import PlayerSidebar from "components/Layout/PlayerSidebar"

const ContentMaxStyled = styled(ContentMax)`
	padding-right: 0;
	padding-left: 0;
	margin-top: 1rem;
	@media ${media.md} {
		/* padding-right: 15px; */
		margin-top: 2rem;
	}
`
const ArticleHeader = styled.div`
	width: 100%;
	
	
	@media ${media.lg} {
		/* padding: 0 15px; */
		padding-top: 0rem;
		padding-right: 12px;
		padding-left: 25px;
	}

	@media (min-width: 1600px) {
		padding-left: 0;
		
	}
`
const ContentWrap = styled.div`
	display: flex;
	flex-wrap: wrap;

	@media ${media.lg} {
		flex-wrap: nowrap;
	}

	.content {
		width: 100%;
		
		@media ${media.lg} {
			/* padding-right: 15px; */
			width: 1078px;  // 1054 + 24px pading
			max-width: calc(100% - 342px); // 330 + 12px padding
		}
	}

	.sidebar {
		width: 100%;
		
		@media ${media.lg} {
			width: 330px;
		}
	}

	.share {
		/* font-size: ${props => props.theme.font.size.lg}; */
		font-size: calc(20px + (26 - 14) * ((100vw - 300px) / (1600 - 300)));
		text-align: left;
		color: ${props => props.theme.colors.primary};
		/* padding: 0 15px; */
		
		@media ${media.md} {
			padding: 0;
			text-align: left;
		}  
		
		.share-button {
			display: inline;
			margin-right: 25px;
			cursor: pointer;
			
			@media ${media.md} {
				margin: 0 25px 0 0;
			}  
		}
		
		span {
			font-family: ${props => props.theme.font.family.bold};
			color: ${props => props.theme.colors.black};
			margin-right: 2rem;
			font-size: ${props => props.theme.font.size.lg};
			@media ${media.md} {
				margin-right: 1.5rem;
			}
		}
		
		svg {
			max-width: 25px;
			max-height: 25px;
			color: ${props => props.theme.colors.primary};
			will-change: transition;
			transition: color .25s ease-in-out;
			&:hover {
				color: ${props => props.theme.colors.secondary};
			}
		}
	}
`

const PlayerStat = styled.div`
	p {
		span {
			color: ${props => props.theme.colors.primary};
		}
	}
`

const FeaturedImageContainer = styled(Container)`
	padding: 0;
	position: relative;

	@media ${media.md} {
		padding-right: ${props => props.theme.bootstrapGutterWidth};
		padding-left: ${props => props.theme.bootstrapGutterWidth};
	}
`

const FeaturedLayout = (props) => {
	useEffect(() => {
    const addPaddingToPage = () => {
      setTimeout(() => {
        const header = document.getElementsByClassName("headerWrap")[0];
				const countdown = document.getElementsByClassName("countdown")[0];
				if (header !== undefined) {
					let headerHeight = header.clientHeight
					if (window.innerWidth < 992) headerHeight = headerHeight + countdown.clientHeight
          document.getElementsByClassName("siteWrap")[0].style.paddingTop = `${headerHeight}px` // 20 = extra padding
        }
      }, 200);
    }

		// const hero = props.data.acfTwoColumnHero?.desktopImage || props.data.template?.acfTwoColumnHero?.desktopImage

		// if (!hero || props.type === "News") {
			addPaddingToPage()
			window.addEventListener('resize', addPaddingToPage)
		// }

		return () => {
			window.removeEventListener('resize', addPaddingToPage)
		}
	}, [])

	const { data, type, breadcrumbs } = props
	let date, shareUrl
	if (props.type === "News") {
		date = data.acfNews && data.acfNews.hidePublishDate === "no" ? true : false
		shareUrl = `${process.env.GATSBY_FRONTEND_URL}${props.uri}`
	}

	const blocks = data.acfTwoColumnFlexibleContent || data.template.acfTwoColumnFlexibleContent 
	const hero = data.template || data;
	return(
		<>
			{(hero.acfTwoColumnHero && type !== "News") &&
				<ContainerMax maxWidth="1920" noPadding>
					<Hero block={hero.acfTwoColumnHero} pageTitle={data.title} />
				</ContainerMax>
			}
			
			{/* {
				hero.acfTwoColumnHero ? <ContainerMax maxWidth="1920" noPadding><Hero block={hero.acfTwoColumnHero} pageTitle={data.title} /></ContainerMax> : ''
			} */}
			<ContentMaxStyled className=" pb-4 pb-md-5">
				<ArticleHeader >
				{(breadcrumbs && type === "News") &&
					<Container fluid>
						<Breadcrumbs $paddingTop breadcrumbs={data.seo.breadcrumbs} />
					</Container>
				}
				{type === "News" &&
					<Container fluid>
						<Text as="h1" $articleHeading className="py-3">{data.title}</Text>
					</Container>
				}
				</ArticleHeader>
				<Article>
					<ContentWrap className="justify-content-lg-between">
						<div className="content">
							{data.acfNews?.featuredImage &&
								<FeaturedImageContainer fluid className="pb-4">
									<GatsbyImage
										image={data.acfNews.featuredImage.localFile.childImageSharp.gatsbyImageData}
										alt={data.acfNews.featuredImage.altText} 
									/>
								</FeaturedImageContainer>
							}
							{type === "Player" &&
								<Container fluid className="pb-4">
									<Text as="h2" $baseheading $uppercase $primary>{data.title}</Text>
								</Container>
							}
							{data.acfPlayers?.playerStats &&
								<Container fluid className="pb-4">
									{data.acfPlayers?.playerStats.map((stat) => {
										return(
											<PlayerStat className="my-1">
												<p><strong>{stat.statName}</strong>: <span><strong>{stat.value}</strong></span></p>
											</PlayerStat>
										)
									})}
								</Container>
							}
							<Row>
								<Col xs={12} className="d-flex flex-wrap px-0">
									{(date && type === "News") &&
										<Container fluid>
											<p className="date">{data.date}</p>
										</Container>
									}
									{blocks && 
										<FlexibleContentFeatured blocks={blocks.twoColumnBlocks} />
									}
								</Col>
							</Row>
						</div>
						<div className="sidebar">
							<aside>
								<Row className="justify-content-center w-100">
									{type === "Player" ? (
										<PlayerSidebar playerId={data.id} />
									) : (
										<Sidebar type={type} data={data} shareUrl={shareUrl} />
									)}
								</Row>
							</aside>
						</div>
					</ContentWrap>
				</Article>
			</ContentMaxStyled>
		</>
	)
}

FeaturedLayout.defaultProps = {
  breadcrumbs: true,
	type: "Default"
}

export default FeaturedLayout